import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles,
  Checkbox,
} from "@material-ui/core";

import { ITheme } from "../constants/theme";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { GetTemporaryInvoiceUrl } from "../service/temporary-access-service";
import { formatShortDate } from "../utils/dateTimeFormatting";
interface IProps {
  data: any;
  onCheckboxChange: (data, value) => void;
  selectedItems: string[];
}
export const AdminInvoiceItem = ({ data, onCheckboxChange, selectedItems }: IProps) => {
  const classes = useStyles();
  const openPdf = async () => {
    GetTemporaryInvoiceUrl(
      data.InvoiceNo,
      async (temporaryUrl) => {
        var win = window.open(temporaryUrl, "_blank");
        win?.focus();
      }
    );
  };

  return (
    <Box data-order="order-item" className={classes.container}>
      <Container className={classes.root}>
        <div className={classes.checkbox}>
          <Checkbox
            checked={selectedItems.includes(data.InvoiceNo)}
            value="remember"
            color="primary"
            onChange={(e: any) => onCheckboxChange(data, e.target.checked)}
          />
        </div>
        <Grid
          item
          container
          xs={12}
          justifyContent="flex-start"
          onClick={openPdf}
        >
          <Grid item>
            <Typography variant="h6" component="span" color="textPrimary">
              {"Invoice " + data.InvoiceNo}
            </Typography>
          </Grid>

          <Grid item container className={classes.gridMargin}>
            <Typography variant="body2" component="span" color="textSecondary">
              {"Order number: " +
                data.OrderNo +
                " \u2022 " +
                formatShortDate(data.OrderDate)}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  container: {
    marginBottom: "24px",
  },
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px 24px",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
    cursor: "pointer",
    transition: "all 200ms ease",
    ...textButtonHoverAndActive
  },
  gridMargin: {
    marginTop: "5px",
  },
  checkbox: {
    paddingRight: 24,
  },
}));
